import { ScaleElement } from '@scale/base-element';
import { Events } from '@scale/events';

class ScaleToast extends ScaleElement {
  #queue = [];
  #showing = false;
  #timer = 0;

  setup() {
    this.onDocument(Events.TOAST, (e) => this.#enqueue(e));
    document.addEventListener('toggle', (event) => {
      if (event.newState === 'open' && event.target.matches('dialog:modal') && this.matches(':popover-open')) this.#front();
    }, { capture: true, signal: this.signal });
  }

  teardown() {
    clearTimeout(this.#timer);
    this.#queue.length = 0;
    this.#showing = false;
  }

  #enqueue(event) {
    if (this.#queue.length >= 5) this.#queue.shift();
    this.#queue.push({
      message: event.message,
      type: event.toastType || 'info',
      duration: event.duration || 4000,
    });
    if (!this.#showing) this.#showNext();
  }

  #showNext() {
    if (this.#queue.length === 0) {
      this.#showing = false;
      this.hidePopover();
      return;
    }

    this.#showing = true;
    const { message, type, duration } = this.#queue.shift();
    const el = this.ref('message');
    el.textContent = message;
    this.dataset.type = type;
    this.#front();
    this.classList.add('is-visible');
    this.announce(message, 'polite');

    this.#timer = setTimeout(() => {
      this.classList.remove('is-visible');
      this.#timer = setTimeout(() => this.#showNext(), 300);
    }, duration);
  }

  #front() {
    if (this.matches(':popover-open')) this.hidePopover();
    this.showPopover();
  }
}

if (!customElements.get('scale-toast')) {
  customElements.define('scale-toast', ScaleToast);
}
